import React from "react"
import PropTypes from "prop-types"
import { Alert, Button } from "reactstrap"

const CampaignPermissionNotice = ({ permissions, deniedMessage = "", permissionLabel = "campaign" }) => {
  const { loading, error, user, reload } = permissions
  if (loading) return <Alert color="info">Checking {permissionLabel} permissions...</Alert>
  if (!error && !deniedMessage) return null

  return (
    <Alert color="danger">
      <div>{error || deniedMessage}</div>
      {user && <div>
        Signed in as {user.user_name || `user ${user.user_id}`} (user ID: {user.user_id}, group ID: {user.user_group}).
      </div>}
      <Button type="button" color="link" className="p-0 mt-2" onClick={reload}>
        Check permissions again
      </Button>
    </Alert>
  )
}

CampaignPermissionNotice.propTypes = {
  permissions: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
    user: PropTypes.object,
    reload: PropTypes.func.isRequired,
  }).isRequired,
  deniedMessage: PropTypes.string,
  permissionLabel: PropTypes.string,
}

export default CampaignPermissionNotice
